<template>
    <div class="count">
        <van-count-down millisecond :time="time" format="HH:mm:ss:SS" @finish="finished">
            <template v-slot="timeData">
                <div class="time" :class="underway ? 'isCome' : 'inProgress'">
                    <span class="item">{{ timeData.days > 9 ? timeData.days : '0' + timeData.days }}</span>
                    <span class="line">天</span>
                    <span class="item">{{ timeData.hours > 9 ? timeData.hours : '0' + timeData.hours }}</span>
                    <span class="line">时</span>
                    <span class="item">{{ timeData.minutes > 9 ? timeData.minutes : '0' + timeData.minutes }}</span>
                    <span class="line">分</span>
                    <span class="item">{{ timeData.seconds  > 9 ? timeData.seconds : '0' + timeData.seconds }}</span>
                    <span class="line">秒</span>
                </div>
            </template>
        </van-count-down>
    </div>
</template>
<script>
export default {
    name: 'vantCount',
    props: {
        time: {
            type: Number,
            default: 0
        },
        millisecond: {
            type: Boolean,
            default: true
        },
        underway: {
            type: Boolean,
            default: true // true 未开始 false 进行中
        }
    },
    methods: {
        finished () {
            this.$emit('onCountDown')
        }
    }
}
</script>
<style lang="scss" scoped>
.count {
    .time{
        display: flex;
        align-items: baseline;
    }
    .isCome {
        color: rgba(179, 179, 179, 1);
    }
    .inProgress {
        color: #ff4d4f;
    }
    span {
        display: inline-block;
        font-size: 28px;
        font-weight: 500;
        &.line {
            vertical-align: bottom;
            padding: 0 4px 0 2px;
            font-size: 20px;
            height: 28px;
            line-height: 28px;
        }
        &.item {
            vertical-align: bottom;
            height: 32px;
            line-height: 32px;
            text-align: center;
            display: inline-block;
            overflow: hidden;
        }
    }
}
</style>